import React from 'react'
import { Route, Switch } from 'react-router'
import Loadable from 'react-loadable'
import Loading from './components/Loading'
import SavedReportsCdp from "./containers/Saved/saved-reports-cdp";
import SavedPayCalendar from "./containers/Saved/pay-calendar";


const Home = Loadable({
    loader: () => import('./containers/Home'),
    loading: Loading
});

const PayContract = Loadable({
    loader: () => import('./containers/ContractPay'),
    loading: Loading
});

const Login = Loadable({
    loader: () => import('./containers/Login'),
    loading: Loading
});

const Dashboard = Loadable({
    loader: () => import('./containers/Dashboard'),
    loading: Loading
});

const Schedule = Loadable({
    loader: () => import('./components/Schedule'),
    loading: Loading
});
const ClinicalConstitution = Loadable({
    loader: () => import('./containers/ClinicalConstitution'),
    loading: Loading
});
const Constitution = Loadable({
    loader: () => import('./components/Constitution'),
    loading: Loading
});
const PerformanceScoreCard = Loadable({
    loader: () => import('./components/PerformanceScoreCard'),
    loading: Loading
});
const PSData = Loadable({
    loader: () => import('./components/PSData'),
    loading: Loading
});
const PowerBI = Loadable({
    loader: () => import('./containers/Reports/PowerBI'),
    loading: Loading
});
const Billing = Loadable({
    loader: () => import('./containers/Billing'),
    loading: Loading
});
const Usage = Loadable({
    loader: () => import('./containers/Usage'),
    loading: Loading
});
const NotAuthorize = Loadable({
    loader: () => import('./components/NotAuthorize'),
    loading: Loading
});
const Adjustments = Loadable({
    loader: () => import('./containers/Reports/Adjustments'),
    loading: Loading
});
const Care = Loadable({
    loader: () => import('./containers/Reports/Care'),
    loading: Loading
});
const CareDeltaReport = Loadable({
    loader: () => import('./containers/Reports/CareDeltaReport'),
    loading: Loading
});
const Soc = Loadable({
    loader: () => import('./containers/Reports/Soc'),
    loading: Loading
});
const Writeoffs = Loadable({
    loader: () => import('./containers/Reports/Writeoffs'),
    loading: Loading
});
const FutureCare = Loadable({
    loader: () => import('./containers/FutureCare'),
    loading: Loading
});
const Practices = Loadable({
    loader: () => import('./containers/Practices'),
    loading: Loading
});
const CareDelta = Loadable({
    loader: () => import('./containers/CareDelta'),
    loading: Loading
});
const ExternalSites = Loadable({
    loader: () => import('./containers/ExternalSites'),
    loading: Loading
});
const DentistView = Loadable({
    loader: () => import('./containers/DentistView'),
    loading: Loading
});
const DoctorContractView = Loadable({
    loader: () => import('./containers/DoctorContractView'),
    loading: Loading
});
const ManageHelpView = Loadable({
    loader: () => import('./containers/ManageHelpView'),
    loading: Loading
});
const TimeoffRequests = Loadable({
    loader: () => import('./containers/TimeoffRequests'),
    loading: Loading
});
const ProviderExpenses = Loadable({
    loader: () => import('./containers/ListExpenses'),
    loading: Loading
});
const ManageProfileView = Loadable({
    loader: () => import('./containers/ManageProfileView'),
    loading: Loading
});
const Bgoal = Loadable({
    loader: () => import('./containers/Bgoal'),
    loading: Loading
});
const BgoalReport = Loadable({
    loader: () => import('./containers/Reports/BgoalReport'),
    loading: Loading
});
const BudgetGoals = Loadable({
    loader: () => import('./containers/Reports/BudgetGoals'),
    loading: Loading
});
const TimeoffRequestReport = Loadable({
    loader: () => import('./containers/Reports/TimeoffRequestReport'),
    loading: Loading
});
const OfferedWorkDaysReport = Loadable({
    loader: () => import('./containers/Reports/OfferedWorkDaysReport'),
    loading: Loading
});
const BitewingReports = Loadable({
    loader: () => import('./containers/Reports/BitewingReports'),
    loading: Loading
});
const CdpReports = Loadable({
    loader: () => import('./containers/ReportsCdp'),
    loading: Loading
});
// [V2-KEEP] CDP Reports served from S3 v2 builds (side-by-side test page; see api/services/payReportsS3/MIGRATION.md)
const CdpReportsS3 = Loadable({
    loader: () => import('./containers/Saved/cdp-reports-s3'),
    loading: Loading
});
const AdjustmentTracker = Loadable({
    loader: () => import('./containers/Saved/adjustment-tracker'),
    loading: Loading
});

const HynTracker = Loadable({
    loader: () => import('./components/HynTracker'),
    loading: Loading
})

const WriteOffHistory = Loadable({
    loader: () => import('./containers/WriteOffHistory'),
    loading: Loading
})

const AdjustmentHistory = Loadable({
    loader: () => import('./containers/AdjustmentHistory'),
    loading: Loading
})

const EarningSending = Loadable({
    loader: () => import('./components/EarningSending'),
    loading: Loading
});

const CdpPay = Loadable({
    loader: () => import('./containers/PayCdp'),
    loading: Loading
});

const TreatingDoctor = Loadable({
    loader: () => import('./containers/TreatingDoctor'),
    loading: Loading
});

const payValidation = Loadable({
    loader: () => import('./containers/PayValidation'),
    loading: Loading
});

const OrthoReports = Loadable({
    loader: () => import('./containers/ReportsOrtho'),
    loading: Loading
});

const OrthoPay = Loadable({
    loader: () => import('./containers/PayOrtho'),
    loading: Loading
});

const ProductionMove = Loadable({
    loader: () => import('./containers/ProductionMove'),
    loading: Loading
});

const SageOrtho = Loadable({
    loader: () => import('./containers/SageOrtho'),
    loading: Loading
});

const UkgOrtho = Loadable({
    loader: () => import('./containers/UkgOrtho'),
    loading: Loading
});

const ScoreCard = Loadable({
    loader: () => import('./components/ScoreCard'),
    loading: Loading
});

const AllAudits = Loadable({
    loader: () => import('./components/Audit/AllAudits'),
    loading: Loading
});

const DashboardAudits = Loadable({
    loader: () => import('./components/Audit/Dashboard'),
    loading: Loading
});
const MyAudits = Loadable({
    loader: () => import('./components/Audit/MyAudits'),
    loading: Loading
});
const ToDoAudits = Loadable({
    loader: () => import('./components/Audit/ToDoAudits'),
    loading: Loading
});
const AuditSetup = Loadable({
    loader: () => import('./components/Audit/Setup'),
    loading: Loading
});
const AuditsResults = Loadable({
    loader: () => import('./components/Audit/Results'),
    loading: Loading
});
const Xray = Loadable({
    loader: () => import('./components/Xray'),
    loading: Loading
});

const orthoPayValidation = Loadable({
    loader: () => import('./containers/OrthoPayValidation'),
    loading: Loading
});

const PatientCodesOrtho = Loadable({
    loader: () => import('./containers/OrthoPatientCodes'),
    loading: Loading
});

const VersionManagement = Loadable({
    loader: () => import('./containers/VersionManagement'),
    loading: Loading
});

const DatabaseVisibility = Loadable({
    loader: () => import('./containers/DatabaseVisibility'),
    loading: Loading
});

const DataFile = Loadable({
    loader: () => import('./containers/DataFile'),
    loading: Loading
});

const routes = (
    <div>
        <Switch>
            <Route exact path="/cdpLogin" component={Home} />
            <Route exact path="/payandreports/ortho-sage/:month?/:year?" component={SageOrtho} />
            <Route exact path="/payandreports/ortho-ukg/:month?/:year?" component={UkgOrtho} />
            <Route exact path="/payandreports/writeoff-history/:month?/:year?" component={WriteOffHistory} />
            <Route exact path="/payandreports/adjustment-history/:month?/:year?" component={AdjustmentHistory} />
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/not-authorize" component={NotAuthorize} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/schedule/:doctorId?" component={Schedule} />
            <Route path="/billing/:abbr?" component={Billing} />
            <Route path="/usage" component={Usage} />
            <Route path="/reports/care" component={Care} />
            <Route path="/reports/care-delta-report" component={CareDeltaReport} />
            <Route path="/reports/adjustments" component={Adjustments} />
            <Route path="/reports/writeoffs" component={Writeoffs} />
            <Route path="/reports/soc" component={Soc} />
            <Route path="/futurecare/:abbr?" component={FutureCare} />
            <Route path="/practices" component={Practices} />
            <Route path="/caredelta/:month?/:year?" component={CareDelta} />
            <Route path="/my-files/:userid?" component={DentistView} />
            <Route path="/doctor-contracts/:userid?" component={DoctorContractView} />
            <Route path="/externalsites" component={ExternalSites} />
            <Route path="/manage-help" component={ManageHelpView} />
            <Route path="/timeoff" component={TimeoffRequests} />
            <Route path="/provider-expenses" component={ProviderExpenses} />
            <Route path="/manage-profile" component={ManageProfileView} />
            <Route path="/bgoal" component={Bgoal} />
            <Route path="/reports/bgoal-report" component={BgoalReport} />
            <Route path="/reports/budget-goals" component={BudgetGoals} />
            <Route path="/reports/timeoff-request-report" component={TimeoffRequestReport} />
            <Route path="/reports/offered-work-days" component={OfferedWorkDaysReport} />
            <Route path="/reports/bitewing-report-notes" component={BitewingReports} />
            <Route path="/clinical/constitution" component={Constitution} />
            <Route path="/clinical/performance-scorecard" component={PerformanceScoreCard} />
            <Route path="/clinical/ps-data" component={PSData} />
            <Route path="/reports/powerbi" component={PowerBI} />
            <Route path="/clinical/clinical-constitution" component={ClinicalConstitution} />
            <Route path="/payandreports/cdp-reports-s3/:month?/:year?" component={CdpReportsS3} />
            <Route path="/payandreports/adjustment-tracker/:month?/:year?" component={AdjustmentTracker} />
            <Route path="/payandreports/cdp-reports/:month?/:year?" component={SavedReportsCdp} />
            <Route path="/payandreports/admin-cdp-reports/:month?/:year?" component={CdpReports} />
            <Route path="/payandreports/admin-cdp-pay/:month?/:year?/:abbr?" component={CdpPay} />
            <Route path="/payandreports/treating-doctor/:month?/:year?" component={TreatingDoctor} />
            <Route path="/payandreports/cdp-pay/:month?/:year?/:abbr?" component={SavedPayCalendar} />
            <Route path="/payandreports/hyn-tracker" component={HynTracker} />
            <Route path="/payandreports/pay-validation" component={payValidation} />
            <Route path="/payandreports/earning-sending" component={EarningSending} />
            <Route path="/payandreports/ortho-pay" component={OrthoPay} />
            <Route path="/payandreports/ortho-change-codes" component={OrthoPay} />
            <Route path="/payandreports/ortho-reports/:month?/:year?" component={OrthoReports} />
            <Route path="/payandreports/pay-contract" component={PayContract} />
            <Route path="/payandreports/productionMove" component={ProductionMove} />
            <Route path="/clinical/score-card" component={ScoreCard} />
            <Route path="/clinical/audit/dashboard" component={DashboardAudits} />
            <Route path="/clinical/audit/my-audits" component={MyAudits} />
            <Route path="/clinical/audit/to-do-audits" component={ToDoAudits} />
            <Route path="/clinical/audit/setup" component={AuditSetup} />
            <Route path="/clinical/audit/all-audits" component={AllAudits} />
            <Route path="/clinical/xray" component={Xray} />
            <Route path="/clinical/audit/results" component={AuditsResults} />
            <Route path="/payandreports/ortho-pay-validation" component={orthoPayValidation} />
            <Route path="/payandreports/ortho-patient-codes/:month?/:year?" component={PatientCodesOrtho} />
            <Route path="/admin/version-management" component={VersionManagement} />
            <Route path="/admin/database-visibility" component={DatabaseVisibility} />
            <Route path="/admin/data-files" component={DataFile} />
        </Switch>
    </div>
)


export default routes
